import components from '../../components'

import palette from 'theme/palette'

import { ratio } from '../../helpers'

import { PADDING } from '../../constants'

import templates from '../../templates'

const introduction = ({ pdf, date, customStyles, skippedPages }) => {
  templates.chapterCover({
    pdf,
    title: 'INTRODUÇÃO',
    subtitle: 'Síntese das principais informações do relatório',
    customStyles,
  })

  pdf.addPage()

  components.lineWithDate(pdf, date)

  components.numberAndTitle(pdf, '1', 'Introdução')

  components.paragraph(
    pdf,
    'Prezados membros da equipe e estimado cliente,\n\nÉ com satisfação que apresentamos o Relatório de Visão Geral, uma análise abrangente sobre o estado atual da adequação da nossa empresa em relação à Lei Geral de Proteção de Dados (LGPD). O objetivo deste relatório é fornecer a você uma visão clara e detalhada dos processos existentes, além de destacar as melhorias potenciais que podem ser implementadas para garantir a conformidade e a proteção dos dados.\n\nEste relatório abrange diversos aspectos fundamentais para a compreensão da situação atual. Primeiramente, apresentamos informações sobre a estrutura da empresa, incluindo a quantidade de usuários e departamentos envolvidos nos processos de tratamento de dados. Essa contextualização é essencial para a avaliação do alcance das atividades relacionadas à LGPD.\n\nAlém disso, fornecemos detalhes sobre o status dos questionários aplicados internamente, que visam mapear o uso de dados pessoais e identificar eventuais lacunas na segurança e conformidade. As respostas obtidas nesses questionários são cruciais para identificar áreas prioritárias que demandam atenção e melhorias.\n\nNo que diz respeito aos processos em si, este relatório apresenta uma análise minuciosa do status de cada um deles. Descrevemos as atividades já finalizadas, destacando os avanços significativos alcançados até o momento. Além disso, fornecemos informações sobre as atividades em andamento, ressaltando os progressos que estão sendo realizados e os prazos estimados para a conclusão de cada etapa.\n\nContudo, é importante salientar que este relatório também identifica pendências gerais que necessitam de atenção imediata. Essas pendências são áreas específicas em que medidas corretivas ou aprimoramentos adicionais são recomendados para fortalecer ainda mais a conformidade com a LGPD e a proteção dos dados dos nossos clientes.\n\nAcreditamos que este Relatório de Visão Geral seja uma ferramenta valiosa para a compreensão da situação atual da nossa empresa em relação à LGPD. Ele fornece uma visão holística e orienta nossos esforços futuros, permitindo que implementemos ações eficazes para atingir um nível ainda maior de conformidade e segurança de dados.',
    ratio(800),
    palette.subscription.primary.main,
  )

  components.numberPage(pdf, palette.black, false, skippedPages)

  pdf.addPage('a4', 'p')

  components.lineWithDate(pdf, date)

  components.paragraph(
    pdf,
    'Agradecemos a sua confiança contínua em nossos serviços e nos colocamos à disposição para quaisquer esclarecimentos adicionais que possam surgir a partir deste relatório. Estamos comprometidos em avançar na jornada de adequação à LGPD e em proteger os dados dos nossos clientes de forma responsável.',
    PADDING,
    palette.subscription.primary.main,
  )

  components.numberPage(pdf, palette.black, false, skippedPages)
}

export default introduction
